import { AnimalForm, AnimalType, animalTypes } from '@app/models/chip.model';
import {
    CHIP_LOCATION_LIST,
    COAT_TYPE_LIST,
    SEX_TYPE_LIST,
    SIZE_LIST,
} from '@app/pages/clinic/models/static.data';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonClickEvent, RadioButtonModule } from 'primeng/radiobutton';

import { CAT_BREEDS_COLLECTION } from '@app/pages/clinic/models/cat-breeds.data';
import { CheckboxModule } from 'primeng/checkbox';
import { DOG_BREEDS } from '@app/pages/clinic/models/dog-breeds.data';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabel } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TranslatePipe } from '@ngx-translate/core';

type AnimalRadioEvent = RadioButtonClickEvent & {
  value: AnimalType;
};

@Component({
    selector: 'app-animal-form',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
        SelectModule,
        InputTextModule,
        DatePickerModule,
        CheckboxModule,
        RadioButtonModule,
        FloatLabel,
    ],
    templateUrl: './animal-form.component.html',
    styleUrl: './animal-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimalFormComponent {
    readonly formGroup = input.required<FormGroup<AnimalForm>>();
    readonly isAddressControlVisible = input<boolean>(true);

    animalTypes = animalTypes;
    breedsList = DOG_BREEDS;
    sexList = SEX_TYPE_LIST;
    chipLocationList = CHIP_LOCATION_LIST;
    coatTypeList = COAT_TYPE_LIST;
    sizeList = SIZE_LIST;
    today = new Date();

    animalTypeChanged({value}: AnimalRadioEvent): void {
        if (value === 'dog') {
            this.breedsList = DOG_BREEDS;
        } else if (value === 'cat') {
            this.breedsList = CAT_BREEDS_COLLECTION;
        } else {
            this.breedsList = [];
        }
        this.formGroup().get('breed')?.setValue(value === 'rabbitFerry' ? null : 1);
    }
}
